import { render, staticRenderFns } from "./quanqiulianjie.vue?vue&type=template&id=3b7329bc&scoped=true&"
import script from "./quanqiulianjie.vue?vue&type=script&lang=js&"
export * from "./quanqiulianjie.vue?vue&type=script&lang=js&"
import style0 from "./quanqiulianjie.vue?vue&type=style&index=0&id=3b7329bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7329bc",
  null
  
)

export default component.exports